var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{staticClass:"bg",attrs:{"fluid":""}},[_c('b-row',[_c('b-col',{attrs:{"cols":"3"}}),_c('b-col',{staticClass:"d-flex justify-content-center",attrs:{"cols":"6"}},[_c('img',{staticClass:"banner",attrs:{"src":require("../assets/Logo2.png"),"alt":""}})]),_c('b-col',{staticClass:"d-flex",attrs:{"cols":"3"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }